import { render, staticRenderFns } from "./PersonalizedGameEditorBool.vue?vue&type=template&id=3b34b250&scoped=true&"
import script from "./PersonalizedGameEditorBool.vue?vue&type=script&lang=js&"
export * from "./PersonalizedGameEditorBool.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b34b250",
  null
  
)

export default component.exports